import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class UserRolePermissionGuard implements CanActivate, CanActivateChild {
    constructor(private router: Router) {}
    /**
     *
     * @param route
     * check role user to active component
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
        /**
         * get role array  to check
         */
        const permissions = route.data.permissionCodes;

        return this.checkRole(permissions);
    }

    /**
     *
     * @param route
     * check role user to active child compoennt
     */
    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
        return this.canActivate(route, state);
    }

    checkRole(permissions: string[]) {
        const roles = atob(localStorage.getItem(btoa('role')));
        if (permissions.some(m => roles.split(',').some(r => r === m))) {
            return true;
        } else {
            this.router.navigate([this.router.url]);
            return false;
        }
    }
}
